var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgListResetveiw = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.9375 7.84688C5.775 5.87813 7.72813 4.5 10 4.5C11.2406 4.5 12.4312 4.99375 13.3094 5.87188L14.9406 7.5H13.25C12.8344 7.5 12.5 7.83437 12.5 8.25C12.5 8.66563 12.8344 9 13.25 9H16.75C17.1656 9 17.5 8.66563 17.5 8.25V4.75C17.5 4.33438 17.1656 4 16.75 4C16.3344 4 16 4.33438 16 4.75V6.44063L14.3719 4.80938C13.2125 3.65 11.6406 3 10 3C7.10625 3 4.62187 4.75625 3.55625 7.25938C3.39375 7.64062 3.57187 8.08125 3.95312 8.24375C4.33438 8.40625 4.775 8.22813 4.9375 7.84688ZM16.4375 12.7531C16.6 12.3719 16.425 11.9313 16.0437 11.7688C15.6625 11.6062 15.2219 11.7812 15.0594 12.1625C14.2188 14.1281 12.2688 15.5 10 15.5C8.75938 15.5 7.56875 15.0063 6.69063 14.1281L5.05938 12.5H6.75C7.16563 12.5 7.5 12.1656 7.5 11.75C7.5 11.3344 7.16563 11 6.75 11H3.25C2.83437 11 2.5 11.3344 2.5 11.75V15.25C2.5 15.6656 2.83437 16 3.25 16C3.66562 16 4 15.6656 4 15.25V13.5594L5.62812 15.1875C6.7875 16.35 8.35938 17 10 17C12.8906 17 15.3687 15.25 16.4375 12.7531Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgListResetveiw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "0dd9432eabd6a1d4dc014c7fd6b6a96b.svg";